import { render, staticRenderFns } from "./veStuAssocEdit.vue?vue&type=template&id=5887e182&scoped=true"
import script from "./veStuAssocEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887e182",
  null
  
)

export default component.exports